export type BaseWidth = {
  appSidebarWidth: string;
  appSidebarWidthCollapsed: string;
  appSidebarNaviIconWidth: string;
  appHeaderMinWidth: string;
  appHeaderMinWidthMobile: string;
  appSidebarESignDrawer: string;
  appSidebarICFDrawer: string;
  appSidebarAuditTrailDrawer: string;
  appMarkerSignatureWidth: string;
  appESignCommonMarkerWidth: string;
};

export const baseWidth: BaseWidth = {
  appSidebarWidth: "200px",
  appSidebarWidthCollapsed: "60px",
  appSidebarNaviIconWidth: "2.8rem",
  appHeaderMinWidth: "450px",
  appHeaderMinWidthMobile: "350px",
  appSidebarESignDrawer: "342px",
  appSidebarICFDrawer: "342px",
  appSidebarAuditTrailDrawer: "340px",
  appMarkerSignatureWidth: "100px",
  appESignCommonMarkerWidth: "200px",
} as const;
